import { api, endpoint } from "@/api";
import { DataTable } from "@/components";
import appConfig from "@/config/appConfig";
import { getFormatedUserType } from "@/utils/userTypeFomater";
import { useSearchQuery } from "@/utils/useSearchQuery";
import { Input, Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FiEdit, FiEye } from "react-icons/fi";
import { LuLayoutDashboard } from "react-icons/lu";

import { Link } from "react-router-dom";
import DefaultDashboardModal from "./DefaultDashboardModal";
import { flare } from "@flareapp/js";

const DefaultDashboardList = () => {
  const role = useSearchQuery("role");
  // const { business } = useSelector((state) => state?.user);

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [businessLoading, setBusinessLoading] = useState(false);
  const [businessList, setBusinessList] = useState([]);
  const [siteLoading, setSiteLoading] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [search, setSearch] = useState({});
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  const { site, business } = search;

  const getUsers = async () => {
    setIsLoading(true);
    try {
      let { results, count } = await api.get("/user/user-with-default-dashboard", {
        params: {
          limit,
          business: business ? [business] : "",
          site,
          page,
          searchText,
          sortBy: "createdAt",
          orderBy: "DESC",
          role: role !== "all" ? role : null,
        },
      });
      results = results.map((item, idx) => {
        item.sl = (page - 1) * limit + idx + 1;
        return item;
      });
      setUsers(results);
      setTotal(count || 0);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };

  const getBusiness = async () => {
    setBusinessLoading(true);
    try {
      const data = await api.get(endpoint.business);
      setBusinessList(data?.data);
      if (Array.isArray(data?.data) && data.data.length === 1) {
        setSearch({ ...search, business: data.data[0]._id });
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("business list", error);
    }
    setBusinessLoading(false);
  };

  const getSiteLocations = async () => {
    setSiteLoading(true);
    try {
      const data = await api.get(`/site-location/my-site`, {
        params: { business, limit: 100000 },
      });
      setSiteList(data);
    } catch {
      setSiteList([]);
    }
    setSiteLoading(false);
  };

  useEffect(() => {
    getUsers();
  }, [page, limit, role, searchText]);

  useEffect(() => {
    getSiteLocations();
  }, [business]);

  useEffect(() => {
    document.title = `${appConfig.name} - Users`;
    getBusiness();
  }, []);

  const columns = [
    {
      title: "No.",
      render: (_, { sl }) => sl,
      width: "40px",
      align: "center",
    },
    {
      title: "User Name",
      render: (_, row) => (
        <div className="d-flex my-2 align-items-center">
          <p className="m-0">{row?.name || "--"}</p>
        </div>
      ),
    },

    {
      title: "User Type",
      render: (_, row) => <div className="text-capitalize">{getFormatedUserType(row.role)}</div>,
      align: "center",
    },

    {
      title: "Default Dashboard",
      render: (_, row) => <div className="text-capitalize">{row?.defaultDashboard?.dashboardName || "--"}</div>,
      align: "center",
    },

    {
      title: "Action",
      align: "center",
      width: "200px",
      render: (_, row) => (
        <div>
          <button onClick={() => showModal(row)} className="btn btn-edit me-1">
            <FiEdit title="Edit Edit Default Settings" />
          </button>
          <Link to={`/users/details/${row._id}?role=${role || "all"}`} className="btn btn-az-primary me-1">
            <FiEye title="View Profile" />
          </Link>

          <button className="btn btn-info me-1" disabled={!row?.defaultDashboard?.dashboardId}>
            <Link to={`/dashboard-list/${row?.defaultDashboard?.dashboardId}`}>
              <LuLayoutDashboard Eye title="View Dashboard" />
            </Link>
          </button>
        </div>
      ),
    },
  ];

  const showModal = (user) => {
    setOpen(true);
    setSelectedUser(user);
  };

  return (
    <div className="card p-3 m-md-3">
      <div className="d-flex flex-column flex-md-row g-3 align-items-md-center mb-3 justify-content-between">
        <div>
          <label className="az-content-label">Manage Users Default Dashboard</label>
          <span className="d-block py-2">All Users</span>
        </div>
      </div>

      <hr className="mt-0" />

      <div className="row mb-2 g-3">
        <div className="col-sm-3">
          <Select
            style={{ width: "100%" }}
            size="large"
            id="business"
            name="business"
            loading={businessLoading}
            allowClear
            maxTagCount={1}
            value={business}
            onChange={(value) => setSearch((prev) => ({ ...prev, business: value, site: null }))}
            showSearch={true}
            filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
            placeholder="All Businesses"
            disabled={businessList?.length === 1}
            options={[...businessList.map((item) => ({ label: `${item.name} (${item.id})`, value: item._id }))]}
            required
          />
        </div>
        <div className="col-sm-3">
          <Select
            style={{ width: "100%" }}
            size="large"
            id="site"
            name="site"
            allowClear
            loading={siteLoading}
            value={site}
            onChange={(value) => setSearch((prev) => ({ ...prev, site: value }))}
            showSearch={true}
            filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
            placeholder="All Site Locations"
            options={[
              ...siteList.map((item) => ({
                label: `${item.name} ${item?.id ? "(" + item.id + ")" : ""} `,
                value: item._id,
              })),
            ]}
            required
          />
        </div>
        <div className="col-sm-3">
          <button
            className="btn bg-secondary-subtle text-black"
            onClick={() => {
              setPage(1);
              getUsers();
            }}
          >
            <FaSearch />
          </button>
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-2">
          <Input
            type="search"
            size="large"
            value={searchText}
            onChange={(e) => {
              setPage(1);
              setSearchText(e.target.value);
            }}
            placeholder="Search"
            className="me-2"
            aria-label="Search"
          />
        </div>
      </div>

      <Spin spinning={isLoading}>
        <DataTable
          dataSource={users}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={{
            defaultPageSize: limit,
            current: page,
            total,
            showSizeChanger: true,
            onShowSizeChange: (_, pageSize) => {
              setLimit(pageSize);
            },
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
            pageSizeOptions: [10, 20, 50],
            responsive: true,
          }}
          onChange={(pagination) => {
            setPage(pagination.current);
          }}
        />
      </Spin>

      <DefaultDashboardModal {...{ open, setOpen, selectedUser, getUsers }} />
    </div>
  );
};

export default DefaultDashboardList;
